module.exports = __webpack_public_path__ + "static/media/close.12f5192b.svg";